import { triggerJingle, updateStation, updateVolume } from '../slices/api/cube';
import { RemotePlayer } from './remote';
import { Jingle } from '../slices/local/user';
import { getSentry } from '../helpers/get-sentry';
import { SPAN_STATUS_OK } from '@sentry/core';
import { ActionHandler } from '../middlewares/orchestrator';
import { setJingleId } from '../slices/local/orchestrator';
import appConfig from '../../app.config';

export class CubePlayer extends RemotePlayer {
  public override changeStation(prevStationId: number): ActionHandler | undefined {
    if (this.state?.stationId === undefined ||
      this.state?.stationId === prevStationId) {
      return undefined;
    }

    return dispatch =>
      getSentry().startSpanManual({
        name: 'change-station',
        attributes: {
          ...this.selector,
          stationId: this.state?.stationId
        }
      }, async span => {
        if (this.state?.stationId === undefined) {
          return;
        }

        await dispatch(updateStation.initiate({
          ...this.selector,
          stationId: this.state?.stationId
        }, { track: false }));

        // @todo
        span.setStatus({ code: SPAN_STATUS_OK });
        span.end();
      });
  }

  public override changeVolume(prevVolume: number, defer: boolean): ActionHandler | undefined {
    if (this.state === undefined || this.state?.volume === undefined) {
      return undefined;
    }

    if (!defer) {
      return undefined;
    }

    return dispatch =>
      getSentry().startSpanManual({
        name: 'change-volume',
        attributes: {
          ...this.selector,
          volume: this.state?.volume
        }
      }, async span => {
        if (this.state?.volume === undefined) {
          return;
        }

        await dispatch(updateVolume.initiate({
          ...this.selector,
          volume: this.state?.volume
        }, { track: false }));

        // @todo
        span.setStatus({ code: SPAN_STATUS_OK });
        span.end();
      });
  }

  public override playJingle(jingle: Jingle | undefined, prevJingleId: number): ActionHandler | undefined {
    // We use this routine for both play and stop
    const jingleId = this.state?.jingleId || prevJingleId;
    if (jingleId === undefined) {
      return undefined;
    }

    return dispatch => getSentry().startSpanManual({
      name: 'play-jingle',
      attributes: {
        ...this.selector,
        jingleId
      }
    }, async span => {
      const result = await dispatch(triggerJingle.initiate({
        ...this.selector,
        jingleId
      }, { track: false }));

      if (result.data?.ok && jingle !== undefined && jingle.duration > 0.0) {
        setTimeout(() => {
          if (this.state?.jingleId === jingleId) {
            dispatch(setJingleId({
              ...this.selector,
              jingleId
            }));
          }
        }, (jingle.duration + appConfig.remoteJingleStopLeeway) * 1000.0);
      }

      span.setStatus(result.data?.sentrySpanStatus);
      span.end();
    });
  }

  public override stopJingle(prevJingleId: number): ActionHandler | undefined {
    return this.playJingle(undefined, prevJingleId);
  }
};
